var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.035,
    height: 19.17,
    viewBox: "0 0 25.035 19.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link",
    transform: "translate(-1.455 -7.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M31.7,8.963a5,5,0,0,0-7.083,0L25.8,10.147a3.341,3.341,0,0,1,4.725,4.725l-6.666,6.666a3.338,3.338,0,1,1-4.725-4.716l1.175-1.183-1.175-1.183-1.183,1.183a5.005,5.005,0,0,0,7.1,7.058l6.666-6.666A5,5,0,0,0,31.7,8.963Z",
    transform: "translate(-6.677)",
    fill: "#00a3ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M4.138,26.034a3.333,3.333,0,0,1,0-4.725L10.8,14.643a3.333,3.333,0,0,1,4.725,0,3.283,3.283,0,0,1,.95,2.375,3.333,3.333,0,0,1-.975,2.375l-1.767,1.792,1.183,1.183L16.687,20.6A5.014,5.014,0,0,0,9.6,13.51L2.93,20.176a4.963,4.963,0,0,0,3.55,8.508,5.058,5.058,0,0,0,3.566-1.467L8.863,26.034a3.333,3.333,0,0,1-4.725,0Z",
    transform: "translate(0 -2.022)",
    fill: "#00a3ae"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.8c633453c36a76dc60daa5385c60ac6a.svg";
export { ForwardRef as ReactComponent };